module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "left-wrapper"
  }, [_c('ul', {
    staticClass: "account-list list-box"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/s-mart/personal_center/notice/",
      "exact": ""
    }
  }, [_vm._v("所有通知")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/s-mart/personal_center/notice/at_me/",
      "exact": ""
    }
  }, [_vm._v("@我的")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "right-wrapper"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6523768f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/notice.vue
// module id = BQMz
// module chunks = 16